import React, { useState } from "react";
import {
  FaPlus,
  FaEllipsisV,
  FaSignOutAlt,
} from "react-icons/fa";
import InstallPWA from "./InstallPWA";
import CustomerList from "./CustomerList";
import DownloadProductExcelTemplate from "./DownloadExcelTemplateMenuItem";

function Header({
  user,
  onLogout,
  onAdd,
  onGenerateBilling,
  uploading,
  handleUpload,
  fileInputRef,
  showActionMenu,
  setShowActionMenu,
  actionMenuRef,
}) {
  const [showCustomers, setShowCustomers] = useState(false);

  return (
    <>
      <header className="pp-header">
        <div className="pp-headerInner">
          <div className="pp-brand">
            <img src="/mtlogo.jpg" alt="MT" className="pp-logo" />
            <h1 className="pp-title">MT Products</h1>
          </div>

          <div className="pp-actions" ref={actionMenuRef}>
            <button className="pp-btnPrimary" onClick={onAdd} type="button">
              <FaPlus size={12} />
              Add
            </button>

            <button
              className="pp-btnIcon"
              onClick={(e) => {
                e.stopPropagation();
                setShowActionMenu((s) => !s);
              }}
              type="button"
            >
              <FaEllipsisV />
            </button>

            {showActionMenu && (
              <div className="pp-menu" onClick={(e) => e.stopPropagation()}>
                <div className="pp-menuHead">
                  <p className="pp-menuUser">{user?.username}</p>
                  <p className="pp-menuSub">Account</p>
                </div>

                <InstallPWA />

                <button
                  className="pp-menuBtn"
                  onClick={() => {
                    setShowActionMenu(false);
                    setShowCustomers(true);
                  }}
                  type="button"
                >
                  👥 View Customers
                </button>

                <button
                  className="pp-menuBtn"
                  onClick={() => {
                    setShowActionMenu(false);
                    onGenerateBilling();
                  }}
                  type="button"
                >
                  🧾 Approval Memo
                </button>

                <label className="pp-menuBtn pp-uploadLabel">
                  <span className="pp-menuEmoji">
                    {uploading ? "🔄" : "🆙"}
                  </span>
                  {uploading ? "Uploading..." : "Import Excel File"}

                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={() =>
                      fileInputRef.current?.files?.[0] && handleUpload()
                    }
                    disabled={uploading}
                    style={{ display: "none" }}
                  />
                </label>

                <DownloadProductExcelTemplate />

                <button
                  className="pp-menuBtn pp-menuBtnDanger"
                  onClick={() => {
                    setShowActionMenu(false);
                    onLogout();
                  }}
                  type="button"
                >
                  <FaSignOutAlt size={13} />
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {showCustomers && (
        <div className="pp-customerModalOverlay">
          <div className="pp-customerModal">
            {/* Fixed header */}
            <div className="pp-customerModalHeader">
              <h2 className="pp-customerModalTitle">Customer List</h2>

              <button
                onClick={() => setShowCustomers(false)}
                className="pp-customerModalClose"
                type="button"
              >
                ✕
              </button>
            </div>

            {/* Scroll only body */}
            <div className="pp-customerModalBody">
              <CustomerList isModal />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;





// import React, { useState } from "react";
// import {
//   FaPlus,
//   FaEllipsisV,
//   FaSignOutAlt,
// } from "react-icons/fa";
// import InstallPWA from "./InstallPWA";
// import CustomerList from "./CustomerList";
// import DownloadProductExcelTemplate from "./DownloadExcelTemplateMenuItem";

// function Header({
//   user,
//   onLogout,
//   onAdd,
//   onGenerateBilling,
//   uploading,
//   handleUpload,
//   fileInputRef,
//   showActionMenu,
//   setShowActionMenu,
//   actionMenuRef,
// }) {
//   // ✅ सही जगह state
//   const [showCustomers, setShowCustomers] = useState(false);

//   return (
//     <>
//       <header className="pp-header">
//         <div className="pp-headerInner">

//           {/* LEFT SIDE */}
//           <div className="pp-brand">
//             <img src="/mtlogo.jpg" alt="MT" className="pp-logo" />
//             <h1 className="pp-title">MT Products</h1>
//           </div>

//           {/* RIGHT SIDE */}
//           <div className="pp-actions" ref={actionMenuRef}>

//             {/* ADD BUTTON */}
//             <button
//               className="pp-btnPrimary"
//               onClick={onAdd}
//               type="button"
//             >
//               <FaPlus size={12} />
//               Add
//             </button>

//             {/* MENU BUTTON */}
//             <button
//               className="pp-btnIcon"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setShowActionMenu((s) => !s);
//               }}
//               type="button"
//             >
//               <FaEllipsisV />
//             </button>

//             {/* DROPDOWN MENU */}
//             {showActionMenu && (
//               <div className="pp-menu" onClick={(e) => e.stopPropagation()}>

//                 <div className="pp-menuHead">
//                   <p className="pp-menuUser">{user?.username}</p>
//                   <p className="pp-menuSub">Account</p>
//                 </div>

//                 <InstallPWA />

//                 {/* ✅ VIEW CUSTOMERS */}
//                 <button
//                   className="pp-menuBtn"
//                   onClick={() => {
//                     setShowActionMenu(false);
//                     setShowCustomers(true);
//                   }}
//                   type="button"
//                 >
//                   👥 View Customers
//                 </button>

//                 {/* BILLING */}
//                 <button
//                   className="pp-menuBtn"
//                   onClick={() => {
//                     setShowActionMenu(false);
//                     onGenerateBilling();
//                   }}
//                   type="button"
//                 >
//                   🧾 Approval Memo
//                 </button>

//                 {/* UPLOAD */}
//                 <label className="pp-menuBtn pp-uploadLabel">
//                   <span className="pp-menuEmoji">
//                     {uploading ? "🔄" : "🆙"}
//                   </span>
//                   {uploading ? "Uploading..." : "Import Excel File"}

//                   <input
//                     ref={fileInputRef}
//                     type="file"
//                     accept=".xlsx,.xls,.csv"
//                     onChange={() =>
//                       fileInputRef.current?.files?.[0] && handleUpload()
//                     }
//                     disabled={uploading}
//                     style={{ display: "none" }}
//                   />
//                 </label>
                 
// <DownloadProductExcelTemplate />

//                 {/* LOGOUT */}
//                 <button
//                   className="pp-menuBtn pp-menuBtnDanger"
//                   onClick={() => {
//                     setShowActionMenu(false);
//                     onLogout();
//                   }}
//                   type="button"
//                 >
//                   <FaSignOutAlt size={13} />
//                   Logout
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </header>

//       {/* ✅ CUSTOMER LIST POPUP */}
//       {showCustomers && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.6)",
//             zIndex: 999,
//           }}
//         >
//           <div
//             style={{
//               background: "#fff",
//               width: "85%",
//               maxHeight: "90vh",
//               overflowY: "auto",
//               margin: "40px auto",
//               padding: 20,
//               borderRadius: 10,
//             }}
//           >
//             {/* CLOSE BUTTON */}
//             <button
//               onClick={() => setShowCustomers(false)}
//               style={{
//                 float: "right",
//                 background: "red",
//                 color: "#fff",
//                 border: "none",
//                 padding: "5px 10px",
//                 borderRadius: 10,
//                 cursor: "pointer",
//               }}
//             >
//               ❌
//             </button>

//             <h2>Customer List</h2>

//             {/* 👉 आपका component */}
//             <CustomerList />
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default Header;









// import React from "react";
// import {
//   FaPlus,
//   FaEllipsisV,
//   FaSignOutAlt,
// } from "react-icons/fa";
// import InstallPWA from "./InstallPWA";

// function Header({
//   user,
//   onLogout,
//   onAdd,
//   onGenerateBilling,
//   uploading,
//   handleUpload,
//   fileInputRef,
//   showActionMenu,
//   setShowActionMenu,
//   actionMenuRef,
// }) {
//   return (
//     <header className="pp-header">
//       <div className="pp-headerInner">
        
//         {/* LEFT SIDE */}
//         <div className="pp-brand">
//           <img src="/mtlogo.jpg" alt="MT" className="pp-logo" />
//           <h1 className="pp-title">MT Products</h1>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className="pp-actions" ref={actionMenuRef}>
          
//           {/* ADD BUTTON */}
//           <button
//             className="pp-btnPrimary"
//             onClick={onAdd}
//             type="button"
//           >
//             <FaPlus size={12} />
//             Add
//           </button>

//           {/* MENU BUTTON */}
//           <button
//             className="pp-btnIcon"
//             onClick={(e) => {
//               e.stopPropagation();
//               setShowActionMenu((s) => !s);
//             }}
//             type="button"
//           >
//             <FaEllipsisV />
//           </button>

//           {/* DROPDOWN MENU */}
//           {showActionMenu && (
//             <div className="pp-menu" onClick={(e) => e.stopPropagation()}>
              
//               <div className="pp-menuHead">
//                 <p className="pp-menuUser">{user?.username}</p>
//                 <p className="pp-menuSub">Account</p>
//               </div>

//               <InstallPWA />

//               {/* BILLING */}
//               <button
//                 className="pp-menuBtn"
//                 onClick={() => {
//                   setShowActionMenu(false);
//                   onGenerateBilling();
//                 }}
//                 type="button"
//               >
//                 <span className="pp-menuEmoji">🧾</span>
//                 Approval Memo
//               </button>

//               {/* UPLOAD */}
//               <label className="pp-menuBtn pp-uploadLabel">
//                 <span className="pp-menuEmoji">
//                   {uploading ? "🔄" : "🆙"}
//                 </span>
//                 {uploading ? "Uploading..." : "Import Excel File"}

//                 <input
//                   ref={fileInputRef}
//                   type="file"
//                   accept=".xlsx,.xls,.csv"
//                   onChange={() =>
//                     fileInputRef.current?.files?.[0] && handleUpload()
//                   }
//                   disabled={uploading}
//                   style={{ display: "none" }}
//                 />
//               </label>

//               {/* LOGOUT */}
//               <button
//                 className="pp-menuBtn pp-menuBtnDanger"
//                 onClick={() => {
//                   setShowActionMenu(false);
//                   onLogout();
//                 }}
//                 type="button"
//               >
//                 <FaSignOutAlt size={13} />
//                 Logout
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// }

// export default Header;